import { render, staticRenderFns } from "./journals.vue?vue&type=template&id=954d7bca&scoped=true"
import script from "./journals.vue?vue&type=script&lang=js"
export * from "./journals.vue?vue&type=script&lang=js"
import style0 from "./journals.vue?vue&type=style&index=0&id=954d7bca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954d7bca",
  null
  
)

export default component.exports